import { Element } from "../api/models/Element";
import { DateTime } from "luxon"
import { secondsBeforeMoment } from "./webinarHelper";
import { COMINGSOON_PERIOD_IN_MINUTES } from "@common/constants"
import { OnlineProvider } from "@api/enums/Session/OnlineProviderEnum";
import {ArrayHelpers} from "@common/ArrayHelpers";

export const setDateTimeForAgenda = (list: Element[]) => {
    return list.map((item) => {
        item.beginAt = DateTime.fromISO(item.beginAt);
        item.endAt = DateTime.fromISO(item.endAt);
        return item
    })
}

const getIsOnlineParam = (session: Element) => {
    const now = DateTime.local();
    return session.beginAt <= now && session.endAt >= now;
}

/**
 * Сan the user open the session via link
 * @param session Session
 * @param isSpeakerOrAdmin current user admin or speaker
 * @param alreadyOpened session alreadt opened in app
 * @returns boolean value
 */
export const mayAttendToSession = (session: Element, isSpeakerOrAdmin: boolean, alreadyOpened: boolean): boolean => {
    const isOnline = typeof session.isOnline === "boolean" ? session.isOnline : getIsOnlineParam(session);
    const secondsBeforeStart = secondsBeforeMoment(session.beginAt);
    const isCommingSoon = secondsBeforeStart < COMINGSOON_PERIOD_IN_MINUTES * 60 && secondsBeforeStart > 0;

    const isPast = session.onlineProvider === OnlineProvider.pastSessionRecord && !alreadyOpened;
    const isClosed = session.isClosed;
    const isLiveCozManual = !isClosed && session.isManualControlled;
    const isEndedByTime = secondsBeforeMoment(session.endAt) < 0;
    const isStarted = session.isStarted;

    /* показ после оконачания */
    const showAfterEnd = !isEndedByTime || isLiveCozManual;

    return isPast || ((isCommingSoon || isOnline || isLiveCozManual || isSpeakerOrAdmin || (isStarted && !isEndedByTime)) && !alreadyOpened && !isClosed && showAfterEnd);
}

export const isShowLiveBadge = (session: Element) => {
    const isNow = getIsOnlineParam(session);
    const isManual = session.isManualControlled;
    const isStarted = session.isStarted;
    const isEndedByTime = secondsBeforeMoment(session.endAt) < 0;
    const isClosed = session.isClosed;

    return (isNow || isManual || (isStarted && !isEndedByTime)) && !isClosed;
}

/**
 * Determines if the given agenda shouldn't be displayed anymore
 * @param agenda
 * @param eventId
 * @param profileGroupIds
 */
export const isAgendaNotForDisplay = (agenda: Element, eventId: string, profileGroupIds: string[]) => {
    const sessionNotAvailableByGroup = agenda.groupIds.length && !ArrayHelpers.intersect(profileGroupIds, agenda.groupIds).length;
    return agenda.eventId !== eventId || !agenda.isPublished || agenda.isDeleted || sessionNotAvailableByGroup;
}